import React, { Fragment, useState } from 'react'
import { Col, Row, CardBody, Card } from 'reactstrap'
import { TabMenu } from 'primereact/tabmenu';
import { IndexQuoterMic } from './IndexQuoterMic';
import { IndexQuoteList } from './IndexQuoteList';
import { CustomAlertModal } from '../../customMoldalAlert/CustomAlertModal';
import { useQuoter } from '../../../hooks/micro/useQuoter';
import { CustomAlertDialogGlobal } from '../../alertDialog/CustomAlertDialogGlobal';

export const IndexTabMenuQuoter = () => {
    const [activeIndex, setActiveIndex] = useState(0);
    const [hideTabs, setHideTabs] = useState(false);
    const [remountKey, setRemountKey] = useState(0);
    const [pendingTab, setPendingTab] = useState(null);
    const [showAlert,setShowAlert] = useState(false);
    const hayDatos = true; 
    const quoterHook = useQuoter();
    const { viewQuoter, customAlert } = quoterHook;
    const isEditing = quoterHook.formQuoterMic.code_quatation !== null;

    const items = [
        {
            label: 'Buscar cotización',
            icon: 'pi pi-search',
            index: 0,
            disabled: isEditing
        },
        {
            label: 'Paciente particular',
            icon: 'pi pi-user',
            index: 1,
            disabled: isEditing
        },
        {
            label: 'Empresas',
            icon: 'pi pi-building',
            index: 2,
            disabled: isEditing
        },
    ];

    const handleTabChange = (e) => {
        const newTab = e.index;
        if (hayDatos) {
            setPendingTab(newTab);
            setShowAlert(true); 
        } else {
            setActiveIndex(newTab);
            setRemountKey(prev => prev + 1);
        }
    };

    const confirmTabChange = () => {
        if (pendingTab !== null) {

            quoterHook.cleanQuoter();

            setActiveIndex(pendingTab);
            setRemountKey(prev => prev + 1);
            setPendingTab(null);
        }

        setShowAlert(false);
    };

    const cancelTabChange = () => {
        setPendingTab(null);
        setShowAlert(false);
    };


   
    return (
        <Fragment>
            <div className='container-global-zoom'>
                <Row>
                    <Col sm="12">
                    {
                    activeIndex === 0 &&
                        <Card style={{
                            marginBottom: '15px',
                            background: 'linear-gradient(135deg, #235e81 0%, #09385b 100%)',
                            border: 'none',
                            boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
                        }}>
                            <CardBody style={{ padding: '15px 25px' }}>
                                <div className="d-flex align-items-center justify-content-between">
                                    <div className="d-flex align-items-center">
                                        <div style={{
                                            width: '50px',
                                            height: '50px',
                                            borderRadius: '12px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            marginRight: '15px'
                                        }}>
                                            <img alt="flask" className="img-fluid text-info mr-2" src={require("../../../assets/images/quoter/quoter-clinics.svg")} style={{ width: "60px", height: "60px" }} />
                                        </div>
                                        <div>
                                            <h4 className="mb-1" style={{ color: '#fff', fontWeight: 700, fontSize: '15px', textAlign: "justify" }}>
                                                Cotizaciones para sanitaría
                                            </h4>
                                            <small style={{ color: 'rgba(255,255,255,0.85)', fontSize: '12px' }}>
                                                <i className="fa fa-info-circle mr-1"></i>
                                                Registrar cotizaciones de servicios sanitarios y dar seguimiento al proceso de muestreo hasta la generación de la orden de trabajo.                            
                                            </small>
                                        </div>
                                    </div>

                                </div>
                            </CardBody>
                        </Card>
                    }
                    {
                    !viewQuoter && (
                        <Card style={{
                            marginBottom: '15px',
                            background: 'linear-gradient(135deg, #002940 0%, #1d5b83 100%)',
                            border: 'none',
                            boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
                        }}>
                            <CardBody
                                style={{
                                    padding: "12px"
                                }}
                            >
                                <div
                                    title={
                                        isEditing
                                            ? "Deshabilitado durante la edición de una cotización"
                                            : ""
                                    }
                                >
                                    {!viewQuoter && (

                                        <TabMenu
                                            model={items}
                                            activeIndex={activeIndex}
                                            onTabChange={handleTabChange}
                                            
                                            className="custom-tabmenu-quoter"

                                        />
                                    )}
                                </div>
                            </CardBody>
                        </Card>
                        )}
                    


                        <div style={{ marginTop: "1rem" }}>
                           <>
                            {activeIndex === 0 && (
                                <IndexQuoteList
                                    quoterHook={quoterHook}
                                    setActiveIndex={setActiveIndex}
                                />
                            )}

                            {activeIndex === 1 && (
                                <IndexQuoterMic
                                    quoterHook={quoterHook}
                                    typeClient={1}
                                    setActiveIndex={setActiveIndex}
                                />
                            )}

                            {activeIndex === 2 && (
                                <IndexQuoterMic
                                    quoterHook={quoterHook}
                                    typeClient={3}
                                    setActiveIndex={setActiveIndex}
                                />
                            )}
                        </>
                        </div>

                        {showAlert && (
                           <CustomAlertModal
                                visible={showAlert}
                                title="¿Cambiar tipo de cotización?"
                                message={`Los datos capturados actualmente se perderán al cambiar entre <strong>Paciente Particular</strong> y <strong>Empresas</strong>.`}
                                buttonText="Sí, continuar"
                                cancelText="Permanecer aquí"
                                onAccept={confirmTabChange}
                                onCancel={cancelTabChange}
                            />
                        )}

                    </Col>
                </Row>
            </div>
            
            <CustomAlertDialogGlobal
                visible={customAlert.visible}
                mode={customAlert.mode}
                type={customAlert.type}
                title={customAlert.title}
                message={customAlert.message}
                buttonText={customAlert.buttonText}
                cancelText={customAlert.cancelText}
                onAccept={customAlert.onAccept}
                onCancel={customAlert.onCancel}
            />
        </Fragment>
    );
};